import { motion } from "framer-motion";
import { FaArrowRight, FaWhatsapp } from "react-icons/fa";
import { PRODUCT_CATEGORIES, COMPANY } from "../data/content";

const ProductCategories = () => (
    <section id="products" data-testid="products-section" className="relative py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="max-w-2xl"
                >
                    <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">Product Range</div>
                    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white leading-tight">
                        Complete <span className="text-gradient-brand">Medical Equipment</span> Catalogue
                    </h2>
                    <p className="mt-4 text-slate-600 dark:text-slate-300">24+ categories spanning hospital, surgical, ICU, laboratory and emergency equipment.</p>
                </motion.div>
                <a
                    href={`https://wa.me/${COMPANY.phoneDigits}?text=${encodeURIComponent("I'd like the full product catalogue")}`}
                    target="_blank" rel="noopener noreferrer"
                    data-testid="catalogue-whatsapp-btn"
                    className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-500 text-white font-semibold text-sm hover:shadow-lg hover:shadow-emerald-500/30 transition self-start sm:self-auto"
                >
                    <FaWhatsapp /> Get Catalogue
                </a>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
                {PRODUCT_CATEGORIES.map((c, i) => (
                    <motion.div
                        key={c.name}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: (i % 8) * 0.04 }}
                        data-testid={`category-card-${i}`}
                        className="group relative rounded-2xl overflow-hidden bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-slate-800 hover:-translate-y-1 hover:shadow-2xl hover:shadow-brand-500/15 transition-all"
                    >
                        <div className="aspect-[4/3] overflow-hidden bg-slate-100 dark:bg-slate-800">
                            <img
                                src={c.img}
                                alt={c.name}
                                loading="lazy"
                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                onError={(e) => { e.currentTarget.src = "https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?auto=compress&cs=tinysrgb&w=600"; }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent opacity-60 group-hover:opacity-80 transition" />
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                            <h3 className="font-heading font-semibold text-white text-sm sm:text-base leading-snug">{c.name}</h3>
                            <a
                                href={`https://wa.me/${COMPANY.phoneDigits}?text=${encodeURIComponent("Enquiry about " + c.name)}`}
                                target="_blank" rel="noopener noreferrer"
                                data-testid={`category-enquiry-${i}`}
                                className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-white/90 hover:text-white"
                            >
                                View Details <FaArrowRight className="text-[10px] group-hover:translate-x-1 transition" />
                            </a>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default ProductCategories;
